import React, { Component } from 'react'
import Layout from '../../components/Layout'
import CrudHeader from '../../components/CrudHeader'
import UserToolbar from '../../components/UserToolbar'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { contentVectorizationActions } from '../../actions'
import { crudListStyle } from '../../styles'
import VetorizacaoNav from '../../components/VetorizacaoNav'
import AddModal from './AddModal'

class ContentVectorization extends Component {
  componentWillUnmount() {
    this.props.resetState()
  }

  render() {
    const { classes, token, modalOpen, closeModal, newFormConteudo, openModal } = this.props

    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title="Vetorização de Conteúdos"
          classes={classes}
          newResource={newFormConteudo}
          openModal={openModal}
          token={token}
          functionality="conteudos"
        />
        <VetorizacaoNav active="conteudos" />
        <ListTable />
        <AddModal open={modalOpen} onClose={closeModal} />
      </Layout>
    )
  }
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
  modalOpen: state.contentVectorization.modalOpen,
})

const mapDispatchToProps = (dispatch) => ({
  resetState: () => dispatch(contentVectorizationActions.resetState()),
  newFormConteudo: () => dispatch(contentVectorizationActions.newFormConteudo()),
  openModal: () => dispatch(contentVectorizationActions.openModal()),
  closeModal: () => dispatch(contentVectorizationActions.closeModal()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(crudListStyle)(ContentVectorization))



// WEBPACK FOOTER //
// ./src/containers/ContentVectorization/index.js